import { render } from "./ModelInfo.vue?vue&type=template&id=567ac330&scoped=true"
import script from "./ModelInfo.vue?vue&type=script&lang=js"
export * from "./ModelInfo.vue?vue&type=script&lang=js"

import "./ModelInfo.vue?vue&type=style&index=0&id=567ac330&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567ac330"]])

export default __exports__